export const googlePlayUrl = 'https://cdn.getyourguide.com/tf/assets/static/badges/google-play-badge-en-us.svg';
